import ApiUtil from './api.util'
import ApiConfig from './api.config'
const platformDomain = ApiConfig.platformDomain
const singleDomain = ApiConfig.singleDomain


function fetchSolutionInfo() {
  const param = {
    "unqUserId": "1000000001A"
  };
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/solutionInfo.json`,param);
}

function fetchFirstUserInfo() {
  const param = {
    "loginUserToken": sessionStorage.getItem("lutk")
  };
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/firstAccessInfo.json`,param);
}

function fetchInsertUserInfo(param) {
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/insertUserInfo.json`,param);
}

function fetchConfirmExistPassword(param) {
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/confirmExistPassword.json`, param);
}

function fetchUpdateFirstUserInfo(param) {
  return ApiUtil.postIncludeUploadFile(`${singleDomain}/v1/ebmp/main/user/updateFirstUserInfo.json`, param);
}

export { fetchSolutionInfo , fetchFirstUserInfo ,fetchInsertUserInfo , fetchConfirmExistPassword, fetchUpdateFirstUserInfo }

